var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1da1f2;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Twitter-2",
    "data-name": "Twitter",
    className: "cls-2",
    d: "M643,708.6c41.26,0,63.82-34.18,63.82-63.82,0-1,0-1.93-.07-2.89a45.74,45.74,0,0,0,11.19-11.61,45,45,0,0,1-12.88,3.53,22.54,22.54,0,0,0,9.86-12.41,45,45,0,0,1-14.24,5.44,22.45,22.45,0,0,0-38.22,20.46,63.65,63.65,0,0,1-46.22-23.43,22.44,22.44,0,0,0,6.94,29.94A22.3,22.3,0,0,1,613,651v.28a22.44,22.44,0,0,0,18,22,22.33,22.33,0,0,1-10.12.38,22.44,22.44,0,0,0,21,15.58,44.86,44.86,0,0,1-33.19,9.29A63.37,63.37,0,0,0,643,708.58",
    transform: "translate(-554 -554)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.0f5c81550fef2d24d4799612847a41c1.svg";
export { ForwardRef as ReactComponent };